import { breakPoints } from 'telia-front-react';
import { action, makeObservable, observable } from 'mobx';

export interface ILayoutStore {
  isMobile: boolean;
  init(): void;
}

export default class LayoutStore {
  @observable
  public isMobile: boolean;

  constructor() {
    makeObservable(this);
  }

  public init(): void {
    window.addEventListener('resize', this.checkIfMobileView.bind(this));
    this.checkIfMobileView();
  }

  @action
  public checkIfMobileView(): void {
    this.isMobile = window.innerWidth < breakPoints.md;
  }
}
